import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { CUSTOM_INTEGRATION_QUOTA, OAUTH2_APPS_QUOTA } from './constants'

export const useCustomIntegrationQuota = () => {
  const { hasQuota, isFetching, quotaSuccess } = useZocksQuota()
  return {
    customIntegrationsEnabled: hasQuota(CUSTOM_INTEGRATION_QUOTA),
    oauth2AppsEnabled: hasQuota(OAUTH2_APPS_QUOTA),
    isFetching,
    quotaSuccess,
  }
}
